import React, { useContext, useState, useRef } from "react";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../BaseUrl";

//functions
import {
  _t,
  getCookie,
  customStyle
} from "../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//3rd party packages
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import Select from "react-select";
import DatePicker from "react-datepicker";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import "react-datepicker/dist/react-datepicker.css";
import { useReactToPrint } from "react-to-print";

//pages & includes
import ReportSidebar from "./ReportSidebar";
import ReportTypeOptions from "../../../components/Reports/ReportTypeOptions";

//context consumer
import { SettingsContext } from "../../../../contexts/Settings";
import { RestaurantContext } from "../../../../contexts/Restaurant";
import CustomSpinLoader from "../../../components/CustomSpinLoader";
import ReportExcelPrintView from "../../../components/Reports/ReportExcelPrintView";

const IngredientConsumptionReport = () => {
  const { t } = useTranslation();
  //getting context values here
  let {
    loading,
    dataPaginating,
    setDataPaginating,
  } = useContext(SettingsContext);
  let { branchForSearch, ingredientItemForSearch } = useContext(RestaurantContext);

  //all data
  const [reportData, setReportData] = useState(null);
  const componentRef = useRef();
  const componentRefThermal = useRef();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [branch, setBranch] = useState(null);
  const [ingredientItem, setIngredientItem] = useState(null);
  const [generatedReport, setGeneratedReport] = useState(false);
  const [option, setOption] = useState("excel");
  const [viewDetailReport, setViewDetailReport] = useState(false);

  const thermalPrint = useReactToPrint({
    content: () => componentRefThermal.current,
    pageStyle: `
        @page {
          margin: 15px 7px;
        }
      `,
  });

  const handleBranch = (branch) => {
    setBranch(branch);
  };

  const handleIngItem = (item) => {
    setIngredientItem(item);
  };

  const handleOption = (e) => {
    setOption(e.target.value);
    if(option !== "view"){
      setViewDetailReport(false)
    }
  };

  //get BranchWise reports filter
  const getBranchWiseFilter = () => {
    setReportData(null);
    setGeneratedReport(false);
    setViewDetailReport(false);
    if (startDate !== null && endDate !== null) {
      setDataPaginating(true);
      let fromDate = moment(startDate).format("YYYY-MM-DD");
      let toDate = moment(endDate).format("YYYY-MM-DD");
      const url = BASE_URL + "/settings/get-ingredient-item-consumption-report";
      const brnch = branch && branch?.length ? JSON.stringify(branch.map((branh)=> branh.id)) : "";
      const ingItem = ingredientItem && ingredientItem?.length ? JSON.stringify(ingredientItem.map((item) => item.id)) : "";

      let formData = new FormData();
      formData.append("fromDate", fromDate);
      formData.append("toDate", toDate);
      formData.append("branch_id", brnch);
      formData.append("ingredient_item_id", ingItem)

      return axios
        .post(url, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        })
        .then((res) => {
          console.log("ReportResult", res);
          setGeneratedReport(true);
          setReportData(res.data);
          setDataPaginating(false);
          if (option === "excel") {
            componentRef.current.handleDownload();
          } else if (option === "view") {
            setViewDetailReport(true)
          } else {
            thermalPrint();
          }
        })
        .catch((error) => {
          setDataPaginating(false);
        });
    } else {
      toast.error(`${_t(t("Please select from date and to date"))}`, {
        position: "bottom-center",
        closeButton: false,
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
    }
  };

  const header = [
    { name:"Item Name", key:"item_name" },
    { name:"Unit", key:"unit_name" },
    { name:"Default Unit", key:"default_unit_name" },
    { name:"Base Qty", key:"base_qty" },
    { name:"Base Amount", key:"base_amount" },
    { name:"Avg Rate", key:"avg_rate" },
  ]

  return (
    <>
      <Helmet>
        <title>{_t(t("Ingredient Consumption Report"))}</title>
      </Helmet>

      <ReactHTMLTableToExcel
        id="test-table-xls-button"
        className="download-table-xls-button btn btn-success float-right mr-3 invisible"
        table="table-to-xls"
        filename="Ingredient Consumption Report"
        sheet="sheet 1"
        buttonText="Download"
        ref={componentRef}
      />

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ReportSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div
                  className="fk-scroll--pos-menu table-bottom-info-hide"
                  data-simplebar
                >
                  <div className="t-pl-15 t-pr-15">
                    {/* next page data spin loading */}
                    <CustomSpinLoader loading={loading || dataPaginating}/>
                    {/* spin loading ends */}
                    <div key="smtp-form">
                      <div className="gx-2 align-items-center t-pt-15 t-pb-15">
                        <div className="row t-mb-15 mb-md-0">
                          <ul className="t-list fk-breadcrumb col-6">
                            <li className="fk-breadcrumb__list">
                              <span className="pl-3 t-link fk-breadcrumb__link text-capitalize">
                                {_t(t("Ingredient Consumption Report"))}
                              </span>
                            </li>
                          </ul>
                          <div className="col-6 d-flex justify-content-end">
                            <ReportTypeOptions
                              selectedOption={option}
                              onChange={handleOption}
                              view={true}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-2">
                          <DatePicker
                            selected={startDate}
                            onChange={(date) => setStartDate(date)}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control t-mb-15"
                            placeholderText={_t(t("From date"))}
                            shouldCloseOnSelect={false}
                          />
                        </div>

                        <div className="col-2">
                          <DatePicker
                            selected={endDate}
                            onChange={(date) => setEndDate(date)}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control t-mb-15"
                            placeholderText={_t(t("To date"))}
                            shouldCloseOnSelect={false}
                          />
                        </div>

                        <div className="col-3">
                          <Select
                            options={branchForSearch ? branchForSearch : []}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            value={branch}
                            styles={customStyle}
                            isMulti
                            isClearable
                            classNamePrefix="select"
                            className="table-text"
                            onChange={handleBranch}
                            maxMenuHeight="200px"
                            placeholder={_t(t("Select a branch")) + ".."}
                          />
                        </div>

                        <div className="col-3">
                          <Select
                            options={ingredientItemForSearch ? ingredientItemForSearch : []}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            value={ingredientItem}
                            styles={customStyle}
                            isMulti
                            isClearable
                            classNamePrefix="select"
                            className="table-text"
                            onChange={handleIngItem}
                            maxMenuHeight="200px"
                            placeholder={_t(t("Select ingredient")) + ".."}
                          />
                        </div>

                        <div className="col-2 t-mb-15 text-right">
                          <button
                            className="ml-1 btn btn-block btn-primary sm-text py-2 rounded"
                            onClick={(e) => getBranchWiseFilter()}
                          >
                            REPORT
                          </button>
                        </div>
                      </div>
                      <ReportExcelPrintView
                        header={header}
                        generatedReport = {generatedReport}
                        viewDetailReport = {viewDetailReport}
                        heading="Ingredient Consumption Report"
                        reportData={reportData}
                        startDate={startDate}
                        endDate={endDate}
                        componentRef={componentRef}
                        printRef={componentRefThermal}
                        branch={{
                          name: branch?.length ? branch.map((branh,i)=> branh.name + (i < branch?.length -1) ? ", " : "" ) : "All Branch",
                          show: true,
                        }}
                        type = {option}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Rightbar contents end*/}
          </div>
        </div>
      </main>
    </>
  );
};

export default IngredientConsumptionReport;
